import { render, staticRenderFns } from "./RecommendedSupplies.vue?vue&type=template&id=19be158c&"
import script from "./RecommendedSupplies.vue?vue&type=script&lang=js&"
export * from "./RecommendedSupplies.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedSupplies.vue?vue&type=style&index=0&id=19be158c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports